export class Projects {
  id: number;
  name = '';
  title = '';
  timeLine = '';
  myRole = '';
  team = '';
  technology = '';
  key = '';
  date = '';
  content = '';
  description = '';
  imageUrl = '';
  buttonText = '';
  buttonUrl = '';
}
